import { useMemo } from 'react';
import type { ContractSub, ContractOwner } from '@/lib/apiClient';
import SubcontractSections from './SubcontractSections';
import OwnerContractSection from './OwnerContractSection';
import { groupSubs, matchesSub, matchesOwner } from './contractsModel';

/**
 * The sheet, rebuilt: subcontracts under its headings, then the owner contracts.
 * The /contracts page and a job's own tab both render this; the only difference
 * is whether the Job column shows.
 */
export default function ContractsBoard({ subcontracts, ownerContracts, search, canEdit, showJob, onEditSub, onEditOwner }: {
  subcontracts: ContractSub[];
  ownerContracts: ContractOwner[];
  search: string;
  canEdit: boolean;
  showJob: boolean;
  onEditSub: (row: ContractSub) => void;
  onEditOwner: (row: ContractOwner) => void;
}) {
  const subs = useMemo(() => subcontracts.filter((r) => matchesSub(r, search)), [subcontracts, search]);
  const owners = useMemo(() => ownerContracts.filter((o) => matchesOwner(o, search)), [ownerContracts, search]);
  const sections = useMemo(() => groupSubs(subs), [subs]);

  if (sections.length === 0 && owners.length === 0) {
    const q = search.trim();
    return (
      <div className="ct-empty">
        {q ? `Nothing matches “${q}”.` : 'Nothing is being tracked yet.'}
      </div>
    );
  }

  return (
    <>
      <SubcontractSections sections={sections} canEdit={canEdit} showJob={showJob} onEdit={onEditSub} />
      <OwnerContractSection rows={owners} canEdit={canEdit} showJob={showJob} onEdit={onEditOwner} />
    </>
  );
}
